import { FC } from 'react';

const Card: FC<{ title: string }> = ({ title, children }) => {
    return (
        <div className="flex flex-col rounded-lg border border-sf-gray-100 w-full h-full">
            <div className="border-b border-sf-gray-100 h-12 pl-4 pr-2 flex items-center text-sf font-medium">
                {title}
            </div>
            <div className="flex-1 overflow-hidden">{children}</div>
        </div>
    );
};

export default Card;
